<template>
    <div class="concept-safe">
        <div class="container">
            <div class="section-grid-oposite">

                <div class="column-container">
                    <div class="col-right">
                        <div class="section-grid-info concept-safe-info">
                            <div class="title">
                                <h3 v-html="conceptArr.section_safe.title"></h3>
                            </div>
                            <div class="desc-html" v-html="conceptArr.section_safe.desc"></div>
                        </div>
                        <div class="section-grid-list-items concept-safe-list-items" v-if="!isMobileG">
                            <ul>
                                <li v-for="(item, index) in conceptArr.section_safe.list" :key="index">
                                    <p v-html="item.desc"></p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-left">
                         <div class="section-images-grid section-images-grid-oposite">
                            <div class="images-items">
                                <div class="item" v-for="(item, index) in conceptArr.section_safe.images" :key="index">
                                    <img :src="item.img" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="section-grid-list-items concept-safe-list-items" v-if="isMobileG">
                    <ul>
                        <li v-for="(item, index) in conceptArr.section_safe.list" :key="index">
                            <p v-html="item.desc"></p>
                        </li>
                    </ul>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
    // import svgIcon from '@/components/partials/SvgIcon.vue';
    // import promoForm from '@/components/forms/form.vue'
    import {mapGetters} from 'vuex'
    export default {
        name: 'concept-safe',
        data () {
            return {
            }
        },
        computed: mapGetters({
            conceptArr: 'loadConcept',
            isMobileG: 'loadisMobileGlobal',
        }),
        components: {
            // svgIcon,
            // promoForm,
        },
        methods: {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/concept/concept-safe.scss';
    @import '@/styles/components/concept/respond/concept-safe-respond.scss';
</style>